import IconHeart from '../../../Icon/Heart';
import IconHeartSolid from '../../../Icon/Heart/Solid';
import ProcessingIndicator from '../../../ProcessingIndicator';
import computeClassName from "../../../../../utils/computeClassName";

const constants = Object.freeze({
  CLASSNAME_BASE: '',
  CLASSNAME_IS_SAVED: {
    true: 'text-cc-alert',
    false: 'text-cc-muted-contrast'
  },
  COMPONENT_IS_SAVED: {
    true: IconHeartSolid,
    false: IconHeart
  }
});

const propsDefaults = Object.freeze({
  isSaved: false,
  isSavingOrRemovingInProgress: false,
  savingOrRemovingInProgressText: 'Processing is in progress...'
});

export default function PartnerSavedStatusIcon(
  {
    isSaved = propsDefaults.isSaved,
    isSavingOrRemovingInProgress = propsDefaults.isSavingOrRemovingInProgress,
    savingOrRemovingInProgressText = propsDefaults.savingOrRemovingInProgressText,
    className = ''
}) {
  const computedClassName = computeClassName(className, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_SAVED[isSaved]}`);
  const IsSavedIconComponent = constants.COMPONENT_IS_SAVED[isSaved];
  return (
    isSavingOrRemovingInProgress ?
      <span className={computedClassName}>
        <ProcessingIndicator size="medium" title={savingOrRemovingInProgressText}/>
      </span> :
      <span className={computedClassName} style={isSaved ? {}:{color:'inherit'}}>
        <IsSavedIconComponent aria-hidden="true" className="!inline"/>
      </span>
  );

}
